package com.heelion.farmafreelance.ui

import androidx.compose.runtime.Composable

@Composable
actual fun rememberSuonoNotifiche(): () -> Unit = ::suonaDing

/**
 * Due note brevi con Web Audio, senza file audio. Se il browser blocca l'audio (nessun tocco
 * dell'utente sulla pagina, es. subito dopo un ricaricamento) semplicemente non suona.
 */
private fun suonaDing() {
    js(
        """
        try {
            var Ctx = window.AudioContext || window.webkitAudioContext;
            var ctx = Ctx ? new Ctx() : null;
            if (ctx) [[880, 0], [1320, 0.15]].forEach(function (n) {
                var osc = ctx.createOscillator();
                var gain = ctx.createGain();
                osc.type = 'sine';
                osc.frequency.value = n[0];
                var t = ctx.currentTime + n[1];
                gain.gain.setValueAtTime(0.0001, t);
                gain.gain.exponentialRampToValueAtTime(0.25, t + 0.02);
                gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.35);
                osc.connect(gain);
                gain.connect(ctx.destination);
                osc.start(t);
                osc.stop(t + 0.4);
            });
            if (ctx) setTimeout(function () { ctx.close(); }, 1000);
        } catch (e) {}
        """
    )
}
